import axios from '../axiosInstance.js';

export const getAllPages = () => axios.get('/pages');